import { Row, Col } from 'reactstrap';
import { InfinitySpin } from 'react-loader-spinner';
function Loader() {
  return <Row><Col md="12" className='text-center'> <InfinitySpin ariaLabel="loading" width='200' color="#4fa94d" /></Col></Row>
}

export default Loader;